import {
  ASSET_STATUS_LABELS,
  type AssetListQuery,
  type AssetStatus,
} from '@gb-ticket/shared-types';

import { toSearchParams } from '@/lib/format';

const EMPTY: AssetListQuery = {
  page: 1,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'asc',
};

export function assetListPath(patch: Partial<AssetListQuery> = {}): string {
  const merged: AssetListQuery = { ...EMPTY, ...patch, page: 1 };
  return `/helpdesk/assets${toSearchParams({
    page: merged.page,
    pageSize: merged.pageSize,
    sortBy: merged.sortBy,
    sortOrder: merged.sortOrder,
    q: merged.q,
    status: merged.status,
    assetTypeId: merged.assetTypeId,
    departmentId: merged.departmentId,
    assignedUserId: merged.assignedUserId,
  })}`;
}

const SEARCH_KEYS = [
  'page',
  'pageSize',
  'sortBy',
  'sortOrder',
  'q',
  'status',
  'assetTypeId',
  'departmentId',
  'assignedUserId',
] as const;

export function assetListQueryFromSearch(search: string): Partial<AssetListQuery> | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  if ([...params.keys()].length === 0) {
    return null;
  }
  const raw: Record<string, string> = {};
  for (const key of SEARCH_KEYS) {
    const value = params.get(key);
    if (value) {
      raw[key] = value;
    }
  }
  if (Object.keys(raw).length === 0) {
    return null;
  }
  const status = raw.status;
  const parsedStatus =
    status && status in ASSET_STATUS_LABELS ? (status as AssetStatus) : undefined;
  return {
    page: raw.page ? Number(raw.page) || 1 : 1,
    pageSize: raw.pageSize ? Number(raw.pageSize) || 25 : 25,
    sortBy: (raw.sortBy as AssetListQuery['sortBy']) || 'name',
    sortOrder: raw.sortOrder === 'desc' ? 'desc' : 'asc',
    q: raw.q,
    status: parsedStatus,
    assetTypeId: raw.assetTypeId,
    departmentId: raw.departmentId,
    assignedUserId: raw.assignedUserId,
  };
}
